/****** choose diamond function ********/
$(document).on("click", ".chooseDiamondLink", function() {
    var diamond = [{
        "diamond_id": $(this).data("diamondid"),
        "diamond_shape": $(this).data("shape"),
        "diamond_price": $(this).data("price"),
        "diamond_name": $(this).data("name"),
      "diamond1_360_url": $("#diamond1_360_url").val(),
      "size" : $(this).data("carat")
    },
     {
       	"diamond_id": $(this).data("diamondid1"),
        "diamond_shape": $(this).data("shape1"),
        "diamond_price": $(this).data("price1"),
        "diamond_name": $(this).data("name1"),
        "diamond2_360_url": $("#diamond2_360_url").val(),
      "size" : $(this).data("carat1")
     }];
    localStorage.setItem("earring_diamond", JSON.stringify(diamond));
  localStorage.setItem('disable_earring_add_to_cart' , 0)
    setSteps("earring_diamond");
    // window.location.href = "/collections/ring-builder-engagement-rings-1";
});


/****** end of choose diamond *****/

/******* Choose Setting function start ******/

$(document).on("click", ".choose-setting", function() {

    var setting = [{
        "product_id": $("#product_id").val(),
      	"product_description": $("#product_description").val(),
        "product_handle": $("#product_handle").val(),
        "setting_id": $("#variant_id").val(),
        "setting_name": $("#variant_name").val(),
        "setting_price": $("#variant_price").val(),
        "setting_metal_type": $("#variant_option1").val(),
        "setting_ring_size": $('#ringsize').val(),
        "setting_sku": $("#variant_sku").val(),
        "setting_url": $("#variant_url").val(),
        "stock_num": $("#stock_num").val(),
        "no_of_center_stone": $("#no_of_center_stone").val(),
        "minimum_carat_total_weight": $("#minimum_carat_total_weight").val().replace('ct','').trim(),
        "maximum_carat_total_weight": $("#maximum_carat_total_weight").val().replace('ct','').trim(),
        "setting_type": $("#setting_type").val(),
        "meta_metal": $("#meta-metal").val(),
        "center_stone": $("#center_stone").val(),
        "can_be_match_with": $("#can_be_match_with").val(),
      "image": $("#gallery-0-thumb").attr("src"),
      "side_stone_weight" : $("#side-stone-weight").val(),
      "pave_stone_weight" : $("#pave-stone-weight").val(),
      "setting_style":$("#setting_type").val(),
      "vendor_code": $("#vendor_code").val().trim(),
    }];
  localStorage.setItem("earring_dia_shape", $("#can_be_match_with").val());
    localStorage.setItem("earring_setting", JSON.stringify(setting));
  localStorage.setItem('disable_earring_add_to_cart' , 0)
    setSteps("earring_setting");
});
/******* Choose Setting function end  ******/


/*** set currenct step and redirect to next step start ****/
function setSteps(current_step) {
	
    if (localStorage.getItem("earring_setting") && localStorage.getItem("earring_diamond")) {
        localStorage.setItem("step3", "final ring");
        var setting_info = JSON.parse(localStorage.getItem("earring_setting"));
        var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));
      	var diamond_price_1 = (diamond_info[0].diamond_price );
      	var diamond_price_2 = (diamond_info[1].diamond_price );
      	var diamond_price = (parseFloat(diamond_price_1) + parseFloat(diamond_price_2));
      	var currency_rate = Shopify.currency.rate;
          var  dia_price = diamond_price * currency_rate; 
        var final_price = parseFloat(setting_info[0].setting_price/100) + parseFloat(dia_price);
      	final_price = parseFloat(final_price).toFixed(2);
      	final_price = Math.ceil(final_price) * 100;
        localStorage.setItem("earring_final_ring_price", final_price);
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true" //"/pages/final-earring";

    } else if (current_step == "earring_diamond" && localStorage.getItem("earring_setting")) {
        localStorage.setItem("earring_step2", "earring_diamond");
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true" //"/pages/final-earring";
    } else if (current_step == "earring_setting" && localStorage.getItem("earring_diamond")) {
        localStorage.setItem("earring_step2", "earring_setting");
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true" //"/pages/final-earring";
    } else if (current_step == "earring_diamond" && !localStorage.getItem("earring_setting")) {
        localStorage.setItem("earring_step1", "earring_diamond");
        localStorage.setItem("earring_step2", "earring_setting");
        window.location.href = tps_config.urls.earring-builder-listing+"?setting_select=true"  //"/collections/earring-builder";
    } else if (current_step == "earring_setting" && !localStorage.getItem("earring_diamond")) {
        localStorage.setItem("earring_step1", "earring_setting");
        localStorage.setItem("earring_step2", "earring_diamond");
        window.location.href =  tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true" //"/pages/earringbuilder-loose-diamond";
    }


}
/*** set currenct step and redirect to next step end ****/

$(document).ready(function() {

  
  if((getQueryVariable('diamond_select') || getQueryVariable('setting_select') || getQueryVariable('id') || getQueryVariable('diamond_id') || window.location.pathname.indexOf('products') > -1  ) ){
   
  }else{
    if(localStorage.getItem("earring_diamond") || localStorage.getItem("earring_setting")){
    	localStorage.removeItem("earring_diamond");
        localStorage.removeItem("earring_setting");
        localStorage.removeItem("final_price");
      	localStorage.removeItem("earring_dia_shape");
        localStorage.removeItem("step1");
        localStorage.removeItem("step2");
        localStorage.removeItem("step3");
        window.location.href = tps_config.urls.earring_builder_listing;
    }
  }
    // window.location.href = "/collections/ring-builder-engagement-rings-1";
});
/*** set currenct step and redirect to next step end ****/



function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
  return false;
}